import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import moment from 'moment'
import ReactTable from 'react-table'
import { Button, Form, Modal, Popconfirm, Input, message, Tooltip } from 'antd'
import InputMask from 'react-input-mask'
import { actions } from '../../redux/modules/companiesActions'
import { actions as addressActions } from '../../redux/modules/addressActions'
import { actions as contactsActions } from '../../redux/modules/contactsActions'
import Attachments from '../../components/attachments/Attachments'
import history from '../../history'
import { filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
import { TextMask, SpanAdapter } from 'react-text-mask-hoc'
import _ from 'lodash'
import Jobs from '../../components/company/Jobs'
import Leads from '../../components/company/Leads'
import Notes from '../../components/notes/Notes'
import ContactsQuickAdd from './ContactsQuickAdd'
import AddressesTable from './AddressesTable'

const propTypes = {}
const FormItem = Form.Item

class Companies extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      addressFormShowing: false,
      contactFormShowing: false,
      content: null,
      currentId: +this.props.match.params.companyId
    }

    this.props.companiesRefresh()
  }

  componentDidUpdate(prevProps) {
    if (
      +this.props.match.params.companyId &&
      this.props.companiesActions &&
      this.props.companiesActions.payload
    ) {
      if (this.props.companiesActions.payload !== prevProps.companiesActions.payload) {
        if (this.props.companiesActions.payload.data) {
          const row = _.find(
            this.props.companiesActions.payload.data,
            company => company.id === this.state.currentId
          )
          this.handleRowClick(row)
        }
      }
    }
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: true,
      content: null,
      currentId: 0
    })
  }

  handleCancel = () => {
    if (+this.props.match.params.companyId) {
      history.push(`/companies`)
    }
    this.props.form.resetFields()
    this.setState({
      data: [],
      currentId: 0,
      modalVisible: false,
      content: null,
      addressData: null,
      addressFormShowing: false,
      contactData: null,
      contactFormShowing: false
    })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createNewCompany({
          company: values,
          userId: this.props.authentication.user.userId
        })
      } else {
        this.props.updateSavedCompany({
          companyId: this.state.currentId,
          company: values,
          userId: this.props.authentication.user.userId
        })
      }
      form.resetFields()
      message.warning('Company created')
      this.setState({ content: null, currentId: 0, modalVisible: false })
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      content: row,
      primaryAddresId: row.address_id,
      primaryContactId: row.contact_id
    })
    this.props.getCompanyAddresses({ companyId: row.id })
    this.props.getCompanyContacts({ companyId: row.id })
    this.props.getAllContacts()
    this.props.getCompanyLeads({ companyId: row.id })
    this.props.getCompanyJobs({ companyId: row.id })
    this.props.getCompanyNote({ companyId: row.id })
    this.props.getAttachments({ companyId: row.id })
  }

  handleAddContactButton = () => {
    this.setState({
      contactFormShowing: true
    })
  }

  handleAddAddressButton = () => {
    this.setState({
      addressFormShowing: true
    })
  }

  handleCreateAddressButton = addressData => {
    this.setState({
      addressFormShowing: false
    })
    this.props.companyCreateAddress({
      userId: this.props.authentication.userId,
      address: addressData,
      companyId: this.state.currentId
    })
  }

  handleCreateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.companyCreateContact({
      userId: this.props.authentication.userId,
      contact: contactData,
      companyId: this.state.currentId
    })
    this.props.getContactList()
  }

  handleSaveAddressButton = addressData => {
    this.props.companyUpdateAddress({
      userId: this.props.authentication.userId,
      addressId: this.state.addressData.id,
      address: addressData,
      companyId: this.state.currentId
    })
    this.setState({
      addressFormShowing: false,
      addressData: null
    })
  }

  handleSaveContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.companyUpdateContact({
      userId: this.props.authentication.userId,
      contactId: this.state.contactData.id,
      contact: contactData,
      companyId: this.state.currentId
    })
  }

  handleCancelContactButton = () => {
    this.setState({
      contactFormShowing: false,
      contactData: {}
    })
  }

  handleCancelAddressButton = () => {
    this.setState({
      addressFormShowing: false,
      addressData: null
    })
  }

  handleDeleteAddress = addressId => {
    this.props.deleteCompanyAddresses({
      addressId,
      companyId: this.state.currentId
    })
  }

  handleDeleteContact = contactId => {
    this.props.deleteCompanyContacts({
      contactId,
      companyId: this.state.currentId
    })
  }

  handleEditAddress = addressData => {
    this.setState({ addressData, addressFormShowing: true })
  }

  handleEditContact = contactData => {
    this.setState({ contactData, contactFormShowing: true })
  }

  handleContactShortcut = id => {
    history.push(`/contacts/${id}`)
  }

  handleCompanyDelete = () => {
    const jobs = _.get(this.props, 'companiesActions.companyJobs.data')
    const leads = _.get(this.props, 'companiesActions.companyLeads.data')

    if (jobs.length > 0 || leads.length > 0) {
      this.setState({
        visibleDeleteModal: true
      })
    } else {
      const form = this.props.form

      this.props.deleteCompany({
        companyId: this.state.currentId
      })

      form.resetFields()
      message.warning('Company deleted')
      this.setState({ content: null, currentId: 0, modalVisible: false })
    }
  }

  handleMakePrimaryAddress = addressId => {
    this.props.updateCompanyPrimaryAddress({
      addressId: addressId,
      companyId: this.state.currentId
    })

    this.setState({
      primaryAddresId: addressId
    })
  }

  handleMakePrimaryContact = contactId => {
    this.props.updateCompanyPrimaryContact({
      contactId: contactId,
      companyId: this.state.currentId
    })

    this.setState({
      primaryContactId: contactId
    })
  }

  handleCancelAndRefreshList = () => {
    this.props.companiesRefresh()
    if (+this.props.match.params.companyId) {
      history.push(`/companies`)
    }
    const form = this.props.form
    form.resetFields()

    this.setState({
      modalVisible: false,
      content: null
    })
  }

  /* attachments */
  uploadAttachment = param => {
    this.props.uploadAttachment({
      formData: param.formData,
      companyId: this.state.currentId
    })
  }

  updateAttachmentDescription = param => {
    this.props.updateAttachmentDescription(param)
  }

  deleteAttachment = param => {
    this.props.deleteAttachment(param)
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createCompanyNote({
      content: params,
      userId: this.props.authentication.userId,
      companyId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editCompanyNote({
      content: params,
      noteId: this.state.currentNoteId,
      companyId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteCompanyNote({
      noteId: this.state.currentNoteId,
      companyId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  /* contact things */
  handleCreateContactButton = contactData => {
    this.props.companyCreateContact({
      userId: this.props.authentication.user.userId,
      contact: contactData,
      companyId: this.state.currentId
    })
  }

  handleCreateContactByIdButton = contactId => {
    this.props.companyCreateContactById({
      userId: this.props.authentication.user.userId,
      contactId: +contactId,
      companyId: this.state.currentId
    })
  }

  handleUpdateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.companyUpdateContact({
      userId: this.props.authentication.user.userId,
      contactId: this.state.contactData.id,
      contact: contactData,
      companyId: this.state.currentId
    })
  }

  handleDeleteContact = contactId => {
    this.props.deleteCompanyContacts({
      contactId,
      companyId: this.state.currentId
    })
  }
  /* end contact things */

  // custom validators
  address1Validator = (rule, value, callback) => {
    if (!this.state.content && !value) {
      callback('Street Address cannot be blank.')
    } else {
      callback()
    }
  }

  cityValidator = (rule, value, callback) => {
    if (!this.state.content && !value) {
      callback('City cannot be blank.')
    } else {
      callback()
    }
  }

  stateValidator = (rule, value, callback) => {
    if (!this.state.content && !value) {
      callback('State cannot be blank.')
    } else {
      callback()
    }
  }

  workNumberValidator = (rule, value, callback) => {
    if (value && value.indexOf('_') != -1) {
      callback('Invalid work number.')
    } else {
      callback()
    }
  }

  hideDeleteModal = () => {
    this.setState({
      visibleDeleteModal: false
    })
  }

  render() {
    const { payload } = this.props.companiesActions
    const { getFieldDecorator } = this.props.form
    const { content } = this.state
    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <Modal
            title="Error deleting company"
            visible={this.state.visibleDeleteModal}
            footer={
              <Button key="back" onClick={this.hideDeleteModal}>
                Ok
              </Button>
            }
            okText="Ok"
          >
            <p>Unable to delete company as it is being used elsewhere.</p>
          </Modal>
          <Modal
            visible={this.state.modalVisible}
            title="Company"
            okText={content ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancelAndRefreshList}
            onOk={this.handleCreate}
            width={content ? '90%' : 800}
            maskClosable={false}
          >
            <div>
              {content && (
                <div className="row" style={{ marginBottom: '15px', marginTop: '15px' }}>
                  <div className="col-md-3">
                    Created by:
                    <strong>{` ${content.created_by_first_name} ${
                      content.created_by_last_name
                    }`}</strong>
                  </div>
                  <div className="col-md-3">
                    Updated by:
                    <strong>{` ${content.updated_by_first_name} ${
                      content.updated_by_last_name
                    }`}</strong>
                  </div>
                  <div className="col-md-3">
                    Created date:{' '}
                    <strong>{moment.utc(content.created_date).format('M/D/YYYY')}</strong>
                  </div>
                  <div className="col-md-3">
                    Updated date:{' '}
                    <strong>{moment.utc(content.updated_date).format('M/D/YYYY')}</strong>
                  </div>
                </div>
              )}
              <Form>
                {!content && (
                  <div>
                    <div className="row">
                      <div className="col-md-12">
                        <FormItem label="Name">
                          {getFieldDecorator('name', {
                            rules: [
                              {
                                required: true,
                                message: 'Name cannot be blank.'
                              }
                            ],
                            initialValue: content ? content.name : ''
                          })(<Input placeholder="Type the company name..." />)}
                        </FormItem>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <FormItem label="Work Number">
                          {getFieldDecorator('work_number', {
                            rules: [
                              {
                                required: true,
                                message: 'Work Number cannot be blank.'
                              },
                              {
                                validator: this.workNumberValidator
                              }
                            ],
                            initialValue:
                              content && content.work_number !== '' ? content.work_number : ''
                          })(
                            <InputMask
                              className="ant-input"
                              mask="(999) 999-9999 ext:9999"
                              maskChar="_"
                            />
                          )}
                        </FormItem>
                      </div>
                      <div className="col-md-6">
                        <FormItem label="Fax Number">
                          {getFieldDecorator('fax_number', {
                            initialValue: ''
                          })(
                            <InputMask
                              className="ant-input"
                              mask="(999) 999-9999 ext:9999"
                              maskChar="_"
                            />
                          )}
                        </FormItem>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <FormItem label="Street Address">
                          {getFieldDecorator('address1', {
                            rules: [
                              {
                                required: true,
                                message: ' '
                              },
                              {
                                validator: this.address1Validator
                              }
                            ],
                            initialValue: ''
                          })(<Input />)}
                        </FormItem>
                      </div>
                      <div className="col-md-6">
                        <FormItem label="Apt/Suite/Floor">
                          {getFieldDecorator('address2', {
                            initialValue: ''
                          })(<Input />)}
                        </FormItem>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <FormItem label="City">
                          {getFieldDecorator('city', {
                            rules: [
                              {
                                required: true,
                                message: ' '
                              },
                              {
                                validator: this.cityValidator
                              }
                            ],
                            initialValue: ''
                          })(<Input />)}
                        </FormItem>
                      </div>
                      <div className="col-md-6">
                        <FormItem label="State">
                          {getFieldDecorator('state', {
                            rules: [
                              {
                                required: true,
                                message: ' '
                              },
                              {
                                validator: this.stateValidator
                              }
                            ],
                            initialValue: ''
                          })(<Input />)}
                        </FormItem>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <FormItem label="Zip">
                          {getFieldDecorator('zip', {
                            initialValue: ''
                          })(<Input />)}
                        </FormItem>
                      </div>
                      <div className="col-md-6" />
                    </div>
                  </div>
                )}
                {content && (
                  <div>
                    <div className="row">
                      <div className="col-md-12">
                        <FormItem label="Name">
                          {getFieldDecorator('name', {
                            rules: [
                              {
                                required: true,
                                message: 'Name cannot be blank.'
                              }
                            ],
                            initialValue: content ? content.name : ''
                          })(<Input placeholder="Type the company name..." />)}
                        </FormItem>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <FormItem label="Work Number">
                          {getFieldDecorator('work_number', {
                            initialValue: content ? content.work_number : ''
                          })(
                            <InputMask
                              className="ant-input"
                              mask="(999) 999-9999 ext:9999"
                              maskChar="_"
                            />
                          )}
                        </FormItem>
                      </div>
                      <div className="col-md-6">
                        <FormItem label="FAX Number">
                          {getFieldDecorator('fax_number', {
                            initialValue: content && content.fax_number ? content.fax_number : ''
                          })(
                            <InputMask
                              className="ant-input"
                              mask="(999) 999-9999 ext:9999"
                              maskChar="_"
                            />
                          )}
                        </FormItem>
                      </div>
                    </div>
                  </div>
                )}
              </Form>
              {content && (
                <div>
                  <AddressesTable
                    addressFormShowing={this.state.addressFormShowing}
                    handleAddAddressButton={this.handleAddAddressButton}
                    handleCancelAddressButton={this.handleCancelAddressButton}
                    handleCreateAddressButton={this.handleCreateAddressButton}
                    handleSaveAddressButton={this.handleSaveAddressButton}
                    addressData={this.state.addressData}
                    addressActions={this.props.addressActions}
                    handleEditAddress={this.handleEditAddress}
                    handleDeleteAddress={this.handleDeleteAddress}
                    cancelDelete={this.cancelDelete}
                    handleMakePrimaryAddress={this.handleMakePrimaryAddress}
                  />
                  <div className="row">
                    <div className="col-md-12">
                      <ContactsQuickAdd
                        handleCreateContactButton={this.handleCreateContactButton}
                        handleUpdateContactButton={this.handleUpdateContactButton}
                        handleCreateContactByIdButton={this.handleCreateContactByIdButton}
                        handleDeleteContact={this.handleDeleteContact}
                        companyContacts={
                          this.props.contactsActions &&
                          this.props.contactsActions.companyContacts &&
                          this.props.contactsActions.companyContacts.data
                        }
                        allContacts={
                          this.props.contactsActions &&
                          this.props.contactsActions.allContacts &&
                          this.props.contactsActions.allContacts.data
                        }
                        handleMakePrimaryContact={this.handleMakePrimaryContact}
                        primaryContactId={this.state.primaryContactId}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <Jobs
                        companyJobs={
                          this.props.companiesActions &&
                          this.props.companiesActions.companyJobs &&
                          this.props.companiesActions.companyJobs.data
                        }
                      />
                    </div>
                  </div>
                  <Leads
                    companyLeads={
                      this.props.companiesActions &&
                      this.props.companiesActions.companyLeads &&
                      this.props.companiesActions.companyLeads.data
                    }
                  />
                  <Notes
                    // notes props
                    currentNote={this.state.currentNote}
                    currentNoteId={this.state.currentNoteId}
                    notes={
                      this.props.companiesActions.companyNotes &&
                      this.props.companiesActions.companyNotes.data
                    }
                    handleToggleNoteEditArea={this.handleToggleNoteEditArea}
                    noteAddEditContainer={this.state.noteAddEditContainer}
                    createNote={this.createNote}
                    handleRowNoteClick={this.handleRowNoteClick}
                    updateNote={this.updateNote}
                    userId={this.props.authentication.user.userId}
                    deleteNote={this.deleteNote}
                  />
                  <div className="row">
                    <div className="col-12">
                      <Attachments
                        currentId={this.state.currentId}
                        userId={this.props.authentication.user.userId}
                        attachmentList={
                          this.props.companiesActions.companyAttachments &&
                          this.props.companiesActions.companyAttachments.data
                        }
                        loadingAttachments={this.props.companiesActions.loadingAttachments}
                        uploadingAttachment={this.props.companiesActions.uploadingAttachment}
                        uploadAttachment={this.uploadAttachment}
                        updateAttachmentDescription={this.updateAttachmentDescription}
                        deleteAttachment={this.deleteAttachment}
                        deletingAttachment={this.props.companiesActions.deletingAttachment}
                      />
                    </div>
                  </div>
                </div>
              )}
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.handleCompanyDelete}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {content && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </div>
          </Modal>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/companies">Companies</Link>
                </li>
              </ol>
            </nav>
            <h2>Companies</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Companies
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel" onClick={() => this.handleAddButton()}>
                    NEW COMPANY
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTdProps={(state, rowInfo, column, instance) => ({
                  onClick: e => {
                    if (column.Header !== undefined) {
                      this.handleRowClick(rowInfo.original)
                    }
                  }
                })}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        id: 'name',
                        accessor: 'name',
                        Cell: d => {
                          return <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                        }
                      },
                      {
                        Header: 'Work Number',
                        accessor: 'work_number',
                        minWidth: 60,
                        Cell: d => (
                          <TextMask
                            Component={SpanAdapter}
                            value={d.original.work_number}
                            mask={[
                              '(',
                              /[1-9]/,
                              /\d/,
                              /\d/,
                              ')',
                              ' ',
                              /\d/,
                              /\d/,
                              /\d/,
                              '-',
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/
                            ]}
                            guide
                          />
                        )
                      },
                      {
                        Header: 'FAX Number',
                        accessor: 'fax_number',
                        minWidth: 60,
                        Cell: d => (
                          <TextMask
                            Component={SpanAdapter}
                            value={d.original.fax_number}
                            mask={[
                              '(',
                              /[1-9]/,
                              /\d/,
                              /\d/,
                              ')',
                              ' ',
                              /\d/,
                              /\d/,
                              /\d/,
                              '-',
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/
                            ]}
                            guide
                          />
                        )
                      },
                      {
                        Header: 'Address',
                        id: 'address',
                        accessor: 'address',
                        minWidth: 120,
                        Cell: d => {
                          const r = `${d.original.address1 !== null && d.original.address1}${
                            d.original.address2 !== null ? ' ' + d.original.address2 : ''
                          }${d.original.city !== null ? ', ' + d.original.city : ''}${
                            d.original.state !== null ? ' - ' + d.original.state : ''
                          }${d.original.zip !== null ? ' - ' + d.original.zip : ''}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        minWidth: 60,
                        Cell: d => {
                          const r = moment.utc(d.original.created_date).format('M/D/YYYY')
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { addressActions, contactsActions, companiesActions, authentication },
  ownProps
) => ({
  addressActions,
  contactsActions,
  companiesActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, addressActions, contactsActions), dispatch)
})

Companies.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Companies)))



// WEBPACK FOOTER //
// ./src/containers/companies/index.js